const FolderPropertiesAction = require('./FolderPropertiesAction');
const actionUtils = require('actions/actionUtils');

module.exports = FolderPropertiesAction.extend({
  isApplicable: function (objs) {
    return this._super(objs);
  }
});
